import { render, staticRenderFns } from "./BetterThead.vue?vue&type=template&id=9db97b7a&scoped=true"
import script from "./BetterThead.vue?vue&type=script&lang=ts"
export * from "./BetterThead.vue?vue&type=script&lang=ts"
import style0 from "./BetterThead.vue?vue&type=style&index=0&id=9db97b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db97b7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
